import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

import { useCurrentActor } from 'components/contexts/CurrentActor';

const provider = 'Procore';

export default function UnlinkProcoreIntegrationModal({
  isUnlinking,
  onClose,
  onUnlink,
  procoreProjectIntegrationCount,
}) {
  const {
    division: {
      attributes: { pluralRAMSName, singularRAMSName },
    },
  } = useCurrentActor();

  const { t: i18nTCommon } = useTranslation('common');

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={onClose}
            size='md'
          >
            {i18nTCommon('shared.cancel')}
          </TextButton>
          <FilledButton color='red' disabled={isUnlinking} onClick={onUnlink}>
            {i18nTCommon('integrations.unlink', { provider })}
          </FilledButton>
        </div>
      }
      isOpen={true}
      mode='flexible'
      onClose={onClose}
      usingSlimDimensions={true}
    >
      <div className='tw-p-8'>
        <h2 className='tw-mb-4 tw-mt-0 tw-text-l tw-font-semibold tw-text-grey-900'>
          {i18nTCommon('integrations.areYouSureYouWantToUnlink', {
            provider,
          })}
        </h2>
        <p className='tw-mb-0'>
          {(() => {
            if (procoreProjectIntegrationCount === 0)
              return i18nTCommon('integrations.noProjectsLinked', {
                interpolation: { escapeValue: false },
                pluralRAMSName,
                provider,
              });
            else
              return i18nTCommon('integrations.projectsLinked', {
                count: procoreProjectIntegrationCount,
                interpolation: { escapeValue: false },
                provider,
                ramsName:
                  procoreProjectIntegrationCount === 1 ? singularRAMSName : (
                    pluralRAMSName
                  ),
              });
          })()}
        </p>
      </div>
    </ModalBox>
  );
}

UnlinkProcoreIntegrationModal.propTypes = {
  isUnlinking: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onUnlink: PropTypes.func.isRequired,
  procoreProjectIntegrationCount: PropTypes.number.isRequired,
};
